<!-- eslint-disable vue/no-deprecated-v-is -->
<template>
  <div @click.capture="handelClick1">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" v-if="$route.meta.keepAlive" :key="$route.name" />
      </keep-alive>
      <component :is="Component" v-if="!$route.meta.keepAlive" :key="$route.name" />
    </router-view>
  </div>
  <van-tabbar
    v-if="$route.meta.tabbar" route :safe-area-inset-bottom="true" active-color="#32DAE2" class="tabbar-list">
    <div class="btn">
      <wx-open-subscribe
        v-if="isWeiXin && IsMobile()" id="launch-btn" template="OUAfc2r_zkkXZ_sOJm5Wp_gKc0YyxgNl2AROvAkesfY"
        @success="(e) => subscribeSuccess(e, 'Knowledge')" @error="(e) => subscribeError(e, 'Knowledge')" @click="handelClick">
        <div v-is="'script'" type="text/wxtag-template">
          <div style="position: absolute;width: 100%;height: 100%;" />
        </div>
      </wx-open-subscribe>
      <van-tabbar-item replace to="/home/knowledge" class="tabbar-item" style="height: 100%;">
        知识热点
        <template #icon="props">
          <svg-icon :icon-class="props.active ? 'tabbar-knowledge-active' : 'tabbar-knowledge'" class="icon" />
        </template>
      </van-tabbar-item>
    </div>
    <div class="btn">
      <wx-open-subscribe
        v-if="isWeiXin && IsMobile()" id="launch-btn" template="OUAfc2r_zkkXZ_sOJm5Wp_gKc0YyxgNl2AROvAkesfY"
        @success="(e) => subscribeSuccess(e, 'HealthManage')" @error="(e) => subscribeError(e, 'HealthManage')" @click="handelClick">
        <div v-is="'script'" type="text/wxtag-template">
          <div style="position: absolute;width: 100%;height: 100%;" />
        </div>
      </wx-open-subscribe>
      <van-tabbar-item replace to="/home/healthManage" class="tabbar-item" style="height: 100%;">
        健康管理
        <template #icon="props">
          <svg-icon :icon-class="props.active ? 'tabbar-health-active' : 'tabbar-health'" class="icon" />
        </template>
      </van-tabbar-item>
    </div>
    <div class="btn">
      <wx-open-subscribe
        v-if="isWeiXin && IsMobile()" id="launch-btn" template="OUAfc2r_zkkXZ_sOJm5Wp_gKc0YyxgNl2AROvAkesfY"
        @success="(e) => subscribeSuccess(e, 'TopicList')" @error="(e) => subscribeError(e, 'TopicList')" @click="handelClick">
        <div v-is="'script'" type="text/wxtag-template">
          <div style="position: absolute;width: 100%;height: 100%;" />
        </div>
      </wx-open-subscribe>
      <van-tabbar-item replace to="/home/topic" class="tabbar-item" style="height: 100%;">
        主题活动
        <template #icon="props">
          <svg-icon :icon-class="props.active ? 'tabbar-topic-active' : 'tabbar-topic'" class="icon" />
        </template>
      </van-tabbar-item>
    </div>
    <div class="btn">
      <wx-open-subscribe
        v-if="isWeiXin && IsMobile()" id="launch-btn" template="OUAfc2r_zkkXZ_sOJm5Wp_gKc0YyxgNl2AROvAkesfY"
        @success="(e) => subscribeSuccess(e, 'UserCenter')" @error="(e) => subscribeError(e, 'UserCenter')" @click="handelClick">
        <div v-is="'script'" type="text/wxtag-template">
          <div style="position: absolute;width: 100%;height: 100%;" />
        </div>
      </wx-open-subscribe>
      <van-tabbar-item replace to="/home/userCenter" class="tabbar-item" style="height: 100%;">
        个人中心
        <template #icon="props">
          <svg-icon :icon-class="props.active ? 'tabbar-user-active' : 'tabbar-user'" class="icon" />
        </template>
      </van-tabbar-item>
    </div>
  </van-tabbar>
  <!-- 填写问卷 -->
  <!-- <img v-if="!question && !_whiteList.includes($route.name)" src="../assets/svg/icon-write.svg" alt="问卷" class="question-icon" @click="handleGoQuestion"> -->
  <!-- <van-dialog
    v-model:show="showQuestion"
    title=""
    confirm-button-text="填写调查问卷"
    confirm-button-color="#45A6FF"
    width="300px"
    :close-on-popstate="true"
    @confirm="handleGoQuestion"
  >
    <div class="question-dialog-tip">
      <h4>亲爱的患友：</h4>
      为了能够了解您的需求并为您提供切实的帮助，我们诚邀您抽 1 分钟的宝贵时间，填写以下几个简单的问题，我们将根据您的建议更加合理地规划平台上的功能及科普内容，希望能够为您提供“蓓加呵护”的服务，帮助您更全面地管理疾病，祝您早日回归美好生活！
    </div>
    <van-icon name="cross" @click="handleClose" />
  </van-dialog> -->
  <van-popup
    v-if="!_whiteList.includes($route.name)" v-model:show="agreeShow" style="border-radius: 24px;" :close-on-click-overlay="false">
    <div class="layout-popup">
      <div class="layout-popup-title">知情同意更新提示</div>
      <div class="layout-popup-content">
        <div class="layout-popup-list" @click="isAgree = !isAgree">
          <img v-if="isAgree" src="@/assets/svg/agree.svg" alt="" class="layout-popup-check">
          <img v-else src="@/assets/svg/agree_no.svg" alt="" class="layout-popup-check">
          <span class="comfirm-popup-desc">我已阅读并接受<span style="color: #45A6FF;" @click.stop="handelLinkUser">《用户协议》</span>和<span style="color: #45A6FF;" @click.stop="handelAgreementPrivacy">《隐私政策》</span></span>
          <!-- <router-link to="/project/userAgreement"></router-link><router-link to="/project/agreementPrivacy"></router-link></span> -->
        </div>
        <div class="layout-popup-list mt20" @click="isAgree1 = !isAgree1">
          <img v-if="isAgree1" src="@/assets/svg/agree.svg" alt="" class="layout-popup-check">
          <img v-else src="@/assets/svg/agree_no.svg" alt="" class="layout-popup-check">
          <span class="layout-popup-desc">我同意根据<span style="color: #45A6FF;" @click.stop="handelAgreementPrivacy">《隐私政策》</span>处理我的敏感个人信息</span>
        </div>
      </div>
      <div class="flex flex-xy-between mt40">
        <div class="layout-popup-cancle" @click="agreeShow = false">不同意</div>
        <div class="layout-popup-sure" @click="handleAgreeConfirm">同意</div>
      </div>
    </div>
  </van-popup>
</template>
<script setup>
import { onMounted, ref, watch, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import router from '@/router'
import { useUserStore } from 'store/user'
import { isWeiXin, IsMobile } from 'utils/index'
import { whitePageList } from 'utils/auth'
import UserApi from 'api/user'

const _whiteList = [...whitePageList, 'OfflineActivitiesSign']
const userStore = useUserStore()

const $route = useRoute()
const { appContext } = getCurrentInstance()
const { $toast } = appContext.config.globalProperties

const showQuestion = ref(false)
const question = ref(0)
watch(() => userStore.questionFill, (newVal) => {
  showQuestion.value = newVal === 'fill'
}, { immediate: true, deep: true })

watch(() => userStore.userInfo.isQuestion, (newVal) => {
  question.value = newVal
}, { immediate: true, deep: true })

const handleGoQuestion = () => {
  router.replace({
    name: 'Question',
    query: {
      redirect: $route.path
    }
  })
}

const handleClose = () => {
  userStore.setQuestionFill($route)
}
const subscribeSuccess = (e, path) => {
  console.log(e)
  router.replace({
    name: path
  })
}

const subscribeError = (e, path) => {
  console.log(e)
  router.replace({
    name: path
  })
}

const isAgree = ref(false)
const isAgree1 = ref(false)
const agreeShow = ref(false)
watch(() => userStore.userInfo.isAgree, (newVal) => {
  if (newVal == 0) {
    agreeShow.value = true
  }
}, { immediate: true, deep: true })

const handleAgreeConfirm = async () => {
  if (!isAgree.value) {
    $toast('请先阅读并勾选《用户协议》和《隐私政策》')
    return
  }
  if (!isAgree1.value) {
    $toast('请勾选同意《隐私政策》处理个人敏感信息')
    return
  }
  await UserApi.isAgree({
    openId: isWeiXin ? userStore.userInfo.openId : undefined,
    token: !isWeiXin ? sessionStorage.getItem('m_token') : undefined
  })
  await userStore.getUserInfo()
  agreeShow.value = false
}
const handelLinkUser = () => {
  router.push({
    path: '/project/userAgreement'
  })
}
const handelAgreementPrivacy = () => {
  router.push({
    path: '/project/agreementPrivacy'
  })
}
const handelClick1 = (event) => {
  if (userStore.userInfo.isAgree == 0) {
    agreeShow.value = true
    event.stopPropagation()
  }
}
</script>
<style lang="less" scoped>
.icon {
  width: 52px;
  height: 52px;
}
.tabbar-list {
  height: 110px;
}
.question-dialog-tip {
  line-height: 42px;
  letter-spacing: 1px;
  padding: 55px;
  h4 {
    margin: 0 0 10px;
    color: #333;
  }
}
.van-icon-cross{
  position: absolute;
  right: 20px;
  top: 20px;
  color: #939393;
}
.question-icon {
  width: 124px;
  height: 124px;
  position: fixed;
  z-index: 99;
  right: 30px;
  bottom: 220px;
}
#launch-btn{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: auto;
}
.btn{
  flex: 1;
  height: 100%;
  position: relative;
  z-index: 22;
}

.layout-popup{
  width: 500px;
  height: 472px;
  background: #FFFFFF;
  border-radius: 24px;
  padding: 40px 55px;
  box-sizing: border-box;
  &-title{
    font-size: 30px;
    font-weight: 600;
    color: #333333;
    line-height: 42px;
    text-align: center;
    margin-bottom: 40px;
  }
  &-content{
    font-size: 24px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
  }
  &-list{
    display: flex;
  }
  &-check{
    width: 32px;
    height: 32px;
    margin-right: 12px;
    margin-left: 17px;
    flex-shrink: 0;
  }
  &-cancle{
    width: 180px;
    height: 70px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #CCCCCC;
    box-sizing: border-box;
    font-size: 28px;
    color: #999999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &-sure{
    width: 180px;
    height: 70px;
    background: #32DAE2;
    border-radius: 16px;
    border: 1px solid #32DAE2;
    box-sizing: border-box;
    font-size: 28px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &-desc{
    display: inline-block;
  }
  a {
    color: #66B4FF;
  }
  .mt40{
    margin-top: 40px;
  }
  .mt20{
    margin-top: 20px;
  }
}
</style>
